import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const getTrackingExpedientes = (idExpediente, soloLineas) => 
async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await fetchConToken(`TrackingExpedientes/TraerPorExpedientes/${idExpediente}/${soloLineas}`)
        const body = await response.json();
        if (response.ok) {
            dispatch({
            type: types.trackingExpedientesSuccess,
            payload: body,
            });
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner())
        dispatch({ type: types.trackingExpedientesError })
        handleErrorApi(dispatch, error, "Error al traer los historial", "Ha ocurrido un error. Intente nuevamente");
    }
}